module.exports = __webpack_public_path__ + "img/why-phone.8cd69c5d.png";